<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Abkürzungsverzeichnis</h4>
    </div>
  </div>
  <mat-card>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig">a. n. g.<br />BWA<br />SO<br />SOC</div>
      <div class="column-zweispaltig">
        anderweitig nicht genannt<br />betriebswirtschaftliche Ausrichtung<br />
        Standardoutput<br />Standardoutput-Koeffizient
      </div>
    </div>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon
            [icon]="faArrowLeft"
            class="ml-1 icon-vertical-align"
          ></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
